import { Story } from '../../schema';
import {
  TripResponse,
  useGetStoriesByTripByTripIdQuery,
  useGetTripsByTripIdQuery,
} from '../../store/backendApi';

interface UseEditTripDataReturn {
  trip: TripResponse | undefined;
  stories: Story[] | undefined;
  isLoadingTrip: boolean;
  isLoadingStories: boolean;
  error: string | null;
}

/**
 * Hook to load trip and stories data for editing.
 * Platform-agnostic: Can be used in React Native.
 *
 * @param tripId - The trip ID to load data for
 * @returns Trip data, stories, loading states, and errors
 */
export const useEditTripData = (tripId?: string): UseEditTripDataReturn => {
  const {
    data: trip,
    error: tripError,
    isLoading: isLoadingTrip,
  } = useGetTripsByTripIdQuery(tripId ?? '', {
    skip: !tripId,
  });

  const {
    data: storiesData,
    error: storiesError,
    isLoading: isLoadingStories,
  } = useGetStoriesByTripByTripIdQuery(tripId ?? '', {
    skip: !tripId,
  });

  // Combine errors
  const error = tripError
    ? 'Could not load trip data'
    : storiesError
      ? 'Could not load stories data'
      : null;

  return {
    trip,
    stories: storiesData?.stories,
    isLoadingTrip,
    isLoadingStories,
    error,
  };
};
